<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
@if (!noSidebar) {
  <fuse-vertical-navigation
    class="dark bg-primary-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- User -->
      <div class="flex flex-col items-center w-full p-4">
        <span class="relative">
          <div class="flex flex-0 items-center justify-center w-20 h-20 rounded-full overflow-hidden">
            <ng-container>
              <div
                class="flex items-center justify-center w-full h-full rounded-full text-lg uppercase bg-gray-200 text-gray-600">
                {{user?.name?.charAt(0) || user?.email?.charAt(0) || '?'}}
              </div>
            </ng-container>
          </div>
        </span>
        <div class="flex flex-col items-center justify-center w-full mt-6">
          @if (user?.name) {
            <div
              class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">
              {{(user?.name || '')}}
            </div>
          }
          <div
            class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
            {{user?.email}}
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container fuseVerticalNavigationFooter>
        <div class="cursor-pointer flex flex-row gap-4" (click)="signOut()" style="padding: 16px 28px; border-top: 1px solid">

        <mat-icon>
          logout
        </mat-icon>
        <div style="opacity: 0.8">
          <span> Logout </span>
        </div>
      </div>
    </ng-container>
  </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0" >

  <!-- Header -->
  @if (!noSidebar) {
    <div
      class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
      <!-- Navigation toggle button -->
      <button
        mat-icon-button
        (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
      </button>
      <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
        <app-select-comune></app-select-comune>
      </div>
    </div>
  }

  <!-- Content -->
  <div class="flex flex-col flex-auto p-4">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>


  <div
    class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
      <div class="w-full flex flex-row justify-between">
      <div class="font-medium text-secondary"> South Engineering srl</div>


      @if (tag) {
        <div style="font-size: 10px"> {{tag}}</div>
      }
    </div>
  </div>

</div>


